import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Roles } from 'src/app/layouts/full/shared/Enums';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { Order, OrderList } from 'src/app/models/order.model';
import { ScanService } from 'src/app/services/scan.service';
import { UserService } from 'src/app/services/user.service';
import { PayOrderModalComponent } from '../pay-order-modal/pay-order-modal.component';

export const ORDER_STATUSES = {
  LABEL: {
    IN_PROGRESS: 'ORDER_IN_PROGRESS',
    SHIPPED: 'ORDER_SHIPPED',
    DELIVERED: 'ORDER_DELIVERED'
  },
  VALUE: {
    IN_PROGRESS: 'inProgress',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered'
  }
}

@Component({
  selector: 'app-manufacturing',
  standalone: true,
  imports: [SharedModule, PayOrderModalComponent],
  templateUrl: './manufacturing.component.html',
  styleUrl: './manufacturing.component.scss'
})
export class ManufacturingComponent {
  public first: number = 0;
  public isApprovingOrder: boolean = false;
  public isPayingOrder: boolean = false;
  public isUserDistributorProfessional: boolean = false;
  public isUserIndividualClient: boolean = false;
  public isUserPrintingHub: boolean = false;
  public loading: boolean = false;
  public moreOrdersParameters: any;
  public orders: Order[] = [];
  public orderStatusOptions: any[] = [];
  public rows: number = 10;
  public selectedOrder: string;
  public selectedOrderToPay: Order;
  public showPayOrderModal: boolean = false;
  displayedColumns: string[] = ['createdAt', 'files', 'price', 'status', 'approved', 'paymentStatus', 'paymentMethod', 'actions', 'orderId']

  constructor(
    public userService: UserService,
    private scanService: ScanService,
    private translateService: TranslateService
  ) { }

  public ngOnInit(): void {
    this.initStatusOptions();
    this.getUserRole();
    this.getOrders();
  }

  public getOrders() {
    this.loading = true;
    this.scanService.getOrders()
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.mapStatusString(response);
          this.saveMoreOrdersSearchParameters(response);
          this.orders = response.orders;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  public isOrderApproved(order: Order): boolean {
    return order.approved && order.paid;
  }

  public onChangeStatus(order: Order): void {
    const request = {
      orderId: order.ID,
      status: order.status
    };

    this.scanService.changeOrderStatus(request)
      .subscribe({
        next: () => {
          order.statusString = this.orderStatusOptions.find(option => option.value === order.status).label;
        },
        error: () => { }
      });
  }

  public onApproveOrder(order: Order): void {
    this.isApprovingOrder = true;
    this.selectedOrder = order.ID;
    const orderId = order.ID;
    this.scanService.approveOrder(orderId)
      .subscribe({
        next: () => {
          order.approved = !order.approved;
          this.isApprovingOrder = false;
          this.selectedOrder = null;
        },
        error: () => {
          this.isApprovingOrder = false;
          this.selectedOrder = null;
        }
      });
  }

  public onPayOrder(order: Order): void {
    this.selectedOrderToPay = order;
    this.showPayOrderModal = true;
  }

  public orderPaid(orderId: any): void {
    this.showPayOrderModal = false;
    this.orders.find(order => order.ID === orderId).paid = true;
  }

  public onLoadMoreOrders(): void {
    const lastOrderId = this.moreOrdersParameters.ID;
    const createdAt = this.moreOrdersParameters.createdAt;
    const userId = this.moreOrdersParameters.userId || this.moreOrdersParameters.printingUserId;
    const role = this.userService.user.role;
    this.moreOrdersParameters = null;

    this.scanService.getMoreOrders(lastOrderId, createdAt, userId, role)
      .subscribe((response) => {
        this.mapStatusString(response);
        this.saveMoreOrdersSearchParameters(response);
        this.orders = this.orders.concat(response.orders);
      });
  }

  public onPageChange(event: any): void {

  }

  private initStatusOptions(): void {
    this.orderStatusOptions = [
      { label: this.translateService.instant(ORDER_STATUSES.LABEL.IN_PROGRESS), value: ORDER_STATUSES.VALUE.IN_PROGRESS },
      { label: this.translateService.instant(ORDER_STATUSES.LABEL.SHIPPED), value: ORDER_STATUSES.VALUE.SHIPPED },
      { label: this.translateService.instant(ORDER_STATUSES.LABEL.DELIVERED), value: ORDER_STATUSES.VALUE.DELIVERED }
    ];
  }

  private getUserRole(): void {
    const userRole = this.userService.user.role;

    if (userRole === Roles.ROLE_DISTRIBUTOR) {
      this.isUserDistributorProfessional = true;
      return;
    }

    if (userRole === Roles.ROLE_INDIVIDUAL_CLIENT) {
      this.isUserIndividualClient = true;
      return;
    }

    if (userRole === Roles.ROLE_PRINTING_HUB) {
      this.isUserPrintingHub = true;
      return;
    }
  }

  private mapStatusString(response: OrderList) {
    response.orders.forEach((order) => {
      order.statusString = this.orderStatusOptions.find(option => option.value === order.status).label;
    });
  }

  private saveMoreOrdersSearchParameters(response: OrderList) {
    if (response.lastEvaluatedKey) {
      this.moreOrdersParameters = response.lastEvaluatedKey;
    }
  }
}
